<template>
  <div @focusin="handleFocusIn" @focusout="handleFocusOut">
    <slot></slot>
  </div>
</template>

<script setup>
import { inject } from "vue";
const FormesterAnalytics = inject("formesterAnalytics");

const handleFocusIn = (event) => {
  if (FormesterAnalytics) {
    FormesterAnalytics.handleFocusIn();
  }
};

const handleFocusOut = (event) => {
  if (FormesterAnalytics) {
    FormesterAnalytics.handleFocusOut(event);
  }
};
</script>
